(() => {
  const config = document.getElementById('cbn-cart-timer-script');
  if (!config || customElements.get('cbn-cart-timer')) return;

  const duration = 15 * 60 * 1000;
  const storageKey = `cbn-cart-timer:v1:${config.dataset.themeId}`;
  const instances = new Set();
  let count = Number(config.dataset.itemCount) || 0;
  let expiresAt = 0;
  let ticker;
  let refreshTimeout;
  let revision = 0;

  function readDeadline() {
    try {
      const value = Number(localStorage.getItem(storageKey));
      return Number.isFinite(value) && value > 0 && value <= Date.now() + duration ? value : 0;
    } catch {
      return expiresAt;
    }
  }

  function saveDeadline() {
    try {
      if (expiresAt) localStorage.setItem(storageKey, String(expiresAt));
      else localStorage.removeItem(storageKey);
    } catch {}
  }

  function render() {
    const remaining = Math.max(0, Math.ceil((expiresAt - Date.now()) / 1000));
    const visible = count > 0 && remaining > 0;
    const value = `${String(Math.floor(remaining / 60)).padStart(2, '0')}:${String(remaining % 60).padStart(2, '0')}`;
    for (const element of instances) {
      element.hidden = !visible;
      const output = element.querySelector('[data-cart-timer-value]');
      if (output && output.textContent !== value) output.textContent = value;
    }
    if (!visible && ticker) {
      clearInterval(ticker);
      ticker = undefined;
    }
  }

  function schedule() {
    render();
    if (count > 0 && expiresAt > Date.now() && !ticker) ticker = setInterval(render, 1000);
  }

  function updateCount(nextCount) {
    if (!Number.isInteger(nextCount) || nextCount < 0) return;
    count = nextCount;
    if (count === 0) {
      expiresAt = 0;
      saveDeadline();
    } else if (!expiresAt) {
      expiresAt = readDeadline() || Date.now() + duration;
      saveDeadline();
    }
    schedule();
  }

  function refreshCart() {
    const currentRevision = ++revision;
    clearTimeout(refreshTimeout);
    refreshTimeout = setTimeout(async () => {
      try {
        const response = await fetch(config.dataset.cartUrl, {
          credentials: 'same-origin',
          cache: 'no-store',
          headers: { Accept: 'application/json' },
        });
        if (!response.ok) return;
        const cart = await response.json();
        if (currentRevision === revision) updateCount(cart.item_count);
      } catch {}
    }, 100);
  }

  class CartTimer extends HTMLElement {
    connectedCallback() {
      instances.add(this);
      render();
    }
    disconnectedCallback() {
      instances.delete(this);
    }
  }

  expiresAt = readDeadline();
  customElements.define('cbn-cart-timer', CartTimer);
  updateCount(count);

  document.addEventListener('cart:update', (event) => {
    if (event.detail?.data?.didError) return;
    const nextCount = event.detail?.resource?.item_count;
    if (Number.isInteger(nextCount)) {
      ++revision;
      clearTimeout(refreshTimeout);
      updateCount(nextCount);
    } else {
      if (event.detail?.eventType === 'cart:add' && count === 0) updateCount(1);
      refreshCart();
    }
  });

  window.addEventListener('storage', (event) => {
    if (event.key !== storageKey && event.key !== null) return;
    expiresAt = readDeadline();
    schedule();
    refreshCart();
  });
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    expiresAt = readDeadline();
    schedule();
    refreshCart();
  });
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') schedule();
  });
})();
